let Lazyload = require('./lazyload');

module.exports = {
  install (Vue) {
    Vue.directive(Lazyload.directiveName, Lazyload);
  }
};
